<template>
  <el-autocomplete
    class="kye-dept-input"
    :value="value"
    ref="autocomplete"
    :clearable="!showArrowIcon"
    :placeholder="placeholder"
    :trigger-on-focus="false"
    :fetch-suggestions="handleChange"
    :format-data="searchParams"
    :format-result="searchFormatResult"
    :id="historyId"
    @focus="handleFocus"
    @blur="handleBlur"
    @input="handleInput"
    @select="chooseDepartment"
    @mouseenter.native="isHover = true"
    @mouseleave.native="isHover = false">
    <i
      slot="prefix"
      v-if="showSearchIcon"
      class="el-icon-search">
    </i>
    <i
      v-if="showArrowIcon"
      slot="suffix"
      class="el-select__caret el-input__icon"
      :class="suffixIcon"
      @mousedown.prevent
      @click.stop="handleIconClick">
    </i>
    <span slot-scope="scope" v-html="scope.item.$name"></span>
  </el-autocomplete>
</template>

<script>

  export default {
    props: {
      value: {
        type: String,
        required: true
      },
      placeholder: {
        type: String,
        default: '请输入或选择组织'
      },
      axios: { // axios
        type: Object,
        default: () => ({})
      },
      searchUrl: String,
      formatResult: Function, // 过滤搜索数据
      searchParams: Function,
      disabled: Boolean,
      showSearchIcon: Boolean,
      showArrowIcon: Boolean,
      isReverse: Boolean,
      historyId: String // 配合输入框的历史记录功能, 实现xPath不能区分节点, 添加指定的historyId确认唯一性
    },
    data () {
      return {
        isFocus: false,
        isHover: false,
      }
    },
    computed: {
      showClear () {
        return !this.disabled && this.value && this.isHover
      },
      suffixIcon () {
        if (this.disabled) {
          return ''
        }
        if (this.showClear) {
          return 'el-icon-circle-close'
        }
        if (this.isReverse && this.isHover) {
          return 'el-icon-arrow-up is-reverse'
        }
        return 'el-icon-arrow-up'
      }
    },
    methods: {
      async handleChange (val, cb) {
        try {
          val = val.trim()
          if (val && val.length > 1) {
            let data = await this.$http(this.searchUrl, this.searchParams(val), this.axios)
            const reg = new RegExp(val, 'gi')
            data.map(item => {
              item.$name = `${item.parentName.replace(reg, value => `<span style="color: #7653D6;">${value}</span>`)},${item.name.replace(reg, value => `<span style="color: #7653D6;">${value}</span>`)}`
            })
            data = this.searchFormatResult(data)
            cb(data)
          } else {
            this.$message.warning('请至少输入2个字符')
            return null
          }
        } catch (error) {
          console.log(error)
        }
      },
      // 过滤搜索结果
      searchFormatResult (res) {
        const formatResult = this.formatResult
        return formatResult ? formatResult(res) : res
      },
      chooseDepartment (item) {
        if (item) {
          this.$emit('input', item.name)
          this.$emit('chooseDepartment', item)
        } else {
          this.clearDepartment()
        }
      },
      handleInput (val) {
        if (!val) {
          this.clearDepartment()
        }
      },
      handleIconClick () {
        if (this.showClear) {
          this.clearDepartment()
        }
      },
      handleFocus () {
        this.isFocus = true
        this.isHover = true
      },
      handleBlur () {
        this.isFocus = false
        this.isHover = false
      },
      blur (value) {
        const autocomplete = this.$refs.autocomplete
        if (autocomplete) {
          autocomplete.$refs.input.currentValue = value
          autocomplete.$refs.input.blur()
        }
      },
      focus () {
        const autocomplete = this.$refs.autocomplete
        autocomplete && autocomplete.$refs.input.focus()
      },
      clearDepartment () {
        this.$emit('input', '')
        this.$emit('clearDepartment')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .kye-dept-input {
    /deep/ .el-input {
      &.el-input--prefix {
        .el-input__inner {
          padding-left: 28px;
        }
        .el-input__prefix {
          left: 8px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/public/components/kye-dept/search-tips.vue